const gtmHit = function(self, { url, seoTitle, templateType, errorPage, statusCode }) {
    self.$nextTick(() => {
        setTimeout(() => {
            window.dataLayer = window.dataLayer || []

            window.dataLayer.push({
                GA360_solution: 'foodlovers',
                GA360_country: 'PL',
                GA360_pageName: `${seoTitle} | PL | ${templateType}`,
                GA360_pageTitle: `${seoTitle} | ${templateType}`,
                GA360_templateType: `${templateType}`,
                GA360_userInterface: 'responsive-site',
                GA360_errorPage: errorPage || 'no-errorpage',
                GA360_statusCode: statusCode || 200
            })

            window.dataLayer.push({
                event: 'page.impression',
                pageType: 'PageView',
                pageUrl: url,
                routeName: 'all'
            })
        }, 0)
    })
}

export default gtmHit
